module.exports = __webpack_public_path__ + "static/ocean-bouquet-190429bab58b097c540ae3c6f0bf6761.jpg";